import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import TopBar from '../../components/TopBar'
import { useAnalytics } from '../../context/AnalyticsContext'
import { getOnboarding, setOnboarding } from './onboardingStorage'
import './onboarding.css'

const OnboardingName = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { trackEvent } = useAnalytics()
  const [name, setName] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    const saved = getOnboarding()
    if (saved.name) setName(saved.name)
  }, [])

  const onBack = () => navigate('/')

  const onContinue = () => {
    const trimmed = name.trim()
    if (!trimmed) {
      setError(t('onboarding.nameRequired'))
      return
    }
    if (trimmed.length > 30) {
      setError(t('onboarding.nameMaxLength'))
      return
    }
    setError('')
    setOnboarding({ name: trimmed })
    trackEvent('funnel_name_completed', { step: 2 })
    navigate('/onboarding/birth')
  }

  return (
    <div className="onboarding-page">
      <TopBar currentStep={2} totalSteps={10} onBack={onBack} showBack={true} />
      <div className="onboarding-content">
        <h1 className="h1">{t('onboarding.nameTitle')}</h1>
        <p className="p">{t('onboarding.nameSubtitle')}</p>

        <div className="field">
          <label className="label">{t('onboarding.nameLabel')}</label>
          <input
            className={`input ${error ? 'error' : ''}`}
            value={name}
            onChange={(e) => {
              setName(e.target.value)
              if (error) setError('')
            }}
            maxLength={30}
            placeholder={t('onboarding.namePlaceholder')}
            autoFocus
          />
          {error ? <div className="error-text">{error}</div> : null}
        </div>
      </div>

      <button className="cta-fixed" onClick={onContinue}>
        {t('common.continue')}
      </button>
    </div>
  )
}

export default OnboardingName

